import * as React from "react";

interface RibbonHeaderProps {
  text?: string;
  future?: boolean;
}

const RibbonHeader = ({
  text,
  future = false,
  ...props
}: RibbonHeaderProps) => {
  return (
    <div className={`ribbon-header ${future ? 'future' : ''}`}>
      <h2>{text}</h2>
    </div>
  );
};
export default RibbonHeader;